import styled from '@emotion/styled';
import { mobileMedia, useResponsive, useScrollPosition } from '@op-bridge/bridge-core';
import { Box, Tab, TabList } from '@node-real/uikit';

const TAB_MAP = ['deposit', 'withdraw'];

export const TabListHistory = () => {
  const { scrollPos } = useScrollPosition(67);
  const { isMobile } = useResponsive();
  return (
    <TabsWrapper
      position={scrollPos && isMobile ? 'sticky' : 'static'}
      background={scrollPos && isMobile ? 'bg.middle' : 'none'}
    >
      <CustomTabList>
        <StyledTab tabKey={TAB_MAP[0]}>Deposits</StyledTab>
        <StyledTab width={[96, 168, 168]} tabKey={TAB_MAP[1]}>
          Withdrawals
        </StyledTab>
      </CustomTabList>
    </TabsWrapper>
  );
};

const TabsWrapper = styled(Box)`
  padding: 0 24px;
  margin: 28px auto 0;
  max-width: 1181px;
  ${mobileMedia} {
    padding: 0 16px;
    margin: 24px auto 0;
    top: 56px;
  }
`;

const CustomTabList = styled(TabList)`
  margin: 0 auto;
  gap: 68px;
  grid-gap: 68px;
  border-bottom: 2px solid ${(props: any) => props.theme.colors.readable.border};
  ${mobileMedia} {
    justify-content: center;
    gap: 0;
  }
`;

const StyledTab = styled(Tab)`
  font-family: Space Grotesk;
  flex-direction: column;
  justify-content: flex-start;
  font-size: 24px;
  font-weight: 500;
  min-width: 124px;
  height: 52px;
  margin-bottom: -2px;
  color: ${(props: any) => props.theme.colors.readable.secondary};
  &[data-selected] {
    font-weight: 700;
    border-bottom: 4px solid ${(props: any) => props.theme.colors.scene.primary.normal};
    color: ${(props: any) => props.theme.colors.readable.normal};
    &:hover {
      color: ${(props: any) => props.theme.colors.readable.normal};
    }
  }
  &:not([data-selected]):hover {
    font-weight: 500;
    border-bottom: 2px solid ${(props: any) => props.theme.colors.scene.primary.normal};
    color: ${(props: any) => props.theme.colors.readable.normal};
  }
  ${mobileMedia} {
    font-size: 16px;
    justify-content: center;
    min-width: 96px;

    &[data-selected] {
      border-bottom: 1.5px solid ${(props: any) => props.theme.colors.scene.primary.normal};
      color: ${(props: any) => props.theme.colors.scene.primary.normal};
      &:hover {
        color: ${(props: any) => props.theme.colors.scene.primary.normal};
      }
    }
    &:not([data-selected]):hover {
      border-bottom: 1.5px solid ${(props: any) => props.theme.colors.scene.primary.normal};
      color: ${(props: any) => props.theme.colors.scene.primary.normal};
    }
  }
  ${mobileMedia} {
    &:last-child {
      margin-left: 64px;
    }
  }
`;
